var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callback-loading"},[_c('depa-bird',{attrs:{"size":64,"flap":"","hover":""}}),_c('div',{staticClass:"callback-text"},[_vm._v("กำลังเข้าสู่ระบบ...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }